let wasm;
export function __wbg_set_wasm(val) {
  wasm = val;
}

const heap = new Array(128).fill(undefined);

heap.push(undefined, null, true, false);

function getObject(idx) {
  return heap[idx];
}

let WASM_VECTOR_LEN = 0;

let cachedUint8ArrayMemory0 = null;

function getUint8ArrayMemory0() {
  if (cachedUint8ArrayMemory0 === null || cachedUint8ArrayMemory0.byteLength === 0) {
    cachedUint8ArrayMemory0 = new Uint8Array(wasm.memory.buffer);
  }
  return cachedUint8ArrayMemory0;
}

const lTextEncoder =
  typeof TextEncoder === "undefined" ? (0, module.require)("util").TextEncoder : TextEncoder;

let cachedTextEncoder = new lTextEncoder("utf-8");

const encodeString =
  typeof cachedTextEncoder.encodeInto === "function"
    ? function (arg, view) {
        return cachedTextEncoder.encodeInto(arg, view);
      }
    : function (arg, view) {
        const buf = cachedTextEncoder.encode(arg);
        view.set(buf);
        return {
          read: arg.length,
          written: buf.length,
        };
      };

function passStringToWasm0(arg, malloc, realloc) {
  if (realloc === undefined) {
    const buf = cachedTextEncoder.encode(arg);
    const ptr = malloc(buf.length, 1) >>> 0;
    getUint8ArrayMemory0()
      .subarray(ptr, ptr + buf.length)
      .set(buf);
    WASM_VECTOR_LEN = buf.length;
    return ptr;
  }

  let len = arg.length;
  let ptr = malloc(len, 1) >>> 0;

  const mem = getUint8ArrayMemory0();

  let offset = 0;

  for (; offset < len; offset++) {
    const code = arg.charCodeAt(offset);
    if (code > 0x7f) break;
    mem[ptr + offset] = code;
  }

  if (offset !== len) {
    if (offset !== 0) {
      arg = arg.slice(offset);
    }
    ptr = realloc(ptr, len, (len = offset + arg.length * 3), 1) >>> 0;
    const view = getUint8ArrayMemory0().subarray(ptr + offset, ptr + len);
    const ret = encodeString(arg, view);

    offset += ret.written;
    ptr = realloc(ptr, len, offset, 1) >>> 0;
  }

  WASM_VECTOR_LEN = offset;
  return ptr;
}

let cachedDataViewMemory0 = null;

function getDataViewMemory0() {
  if (
    cachedDataViewMemory0 === null ||
    cachedDataViewMemory0.buffer.detached === true ||
    (cachedDataViewMemory0.buffer.detached === undefined &&
      cachedDataViewMemory0.buffer !== wasm.memory.buffer)
  ) {
    cachedDataViewMemory0 = new DataView(wasm.memory.buffer);
  }
  return cachedDataViewMemory0;
}

const lTextDecoder =
  typeof TextDecoder === "undefined" ? (0, module.require)("util").TextDecoder : TextDecoder;

let cachedTextDecoder = new lTextDecoder("utf-8", { ignoreBOM: true, fatal: true });

cachedTextDecoder.decode();

function getStringFromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  return cachedTextDecoder.decode(getUint8ArrayMemory0().subarray(ptr, ptr + len));
}

let heap_next = heap.length;

function addHeapObject(obj) {
  if (heap_next === heap.length) heap.push(heap.length + 1);
  const idx = heap_next;
  heap_next = heap[idx];

  heap[idx] = obj;
  return idx;
}

function handleError(f, args) {
  try {
    return f.apply(this, args);
  } catch (e) {
    wasm.__wbindgen_exn_store(addHeapObject(e));
  }
}

function dropObject(idx) {
  if (idx < 132) return;
  heap[idx] = heap_next;
  heap_next = idx;
}

function takeObject(idx) {
  const ret = getObject(idx);
  dropObject(idx);
  return ret;
}

function isLikeNone(x) {
  return x === undefined || x === null;
}

const CLOSURE_DTORS =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((state) => {
        wasm.__wbindgen_export_4.get(state.dtor)(state.a, state.b);
      });

function makeMutClosure(arg0, arg1, dtor, f) {
  const state = { a: arg0, b: arg1, cnt: 1, dtor };
  const real = (...args) => {
    // First up with a closure we increment the internal reference
    // count. This ensures that the Rust closure environment won't
    // be deallocated while we're invoking it.
    state.cnt++;
    const a = state.a;
    state.a = 0;
    try {
      return f(a, state.b, ...args);
    } finally {
      if (--state.cnt === 0) {
        wasm.__wbindgen_export_4.get(state.dtor)(a, state.b);
        CLOSURE_DTORS.unregister(state);
      } else {
        state.a = a;
      }
    }
  };
  real.original = state;
  CLOSURE_DTORS.register(real, state, state);
  return real;
}

function debugString(val) {
  // primitive types
  const type = typeof val;
  if (type == "number" || type == "boolean" || val == null) {
    return `${val}`;
  }
  if (type == "string") {
    return `"${val}"`;
  }
  if (type == "symbol") {
    const description = val.description;
    if (description == null) {
      return "Symbol";
    } else {
      return `Symbol(${description})`;
    }
  }
  if (type == "function") {
    const name = val.name;
    if (typeof name == "string" && name.length > 0) {
      return `Function(${name})`;
    } else {
      return "Function";
    }
  }
  // objects
  if (Array.isArray(val)) {
    const length = val.length;
    let debug = "[";
    if (length > 0) {
      debug += debugString(val[0]);
    }
    for (let i = 1; i < length; i++) {
      debug += ", " + debugString(val[i]);
    }
    debug += "]";
    return debug;
  }
  // Test for built-in
  const builtInMatches = /\[object ([^\]]+)\]/.exec(toString.call(val));
  let className;
  if (builtInMatches && builtInMatches.length > 1) {
    className = builtInMatches[1];
  } else {
    // Failed to match the standard '[object ClassName]'
    return toString.call(val);
  }
  if (className == "Object") {
    // we're a user defined class or Object
    // JSON.stringify avoids problems with cycles, and is generally much
    // easier than looping through ownProperties of `val`.
    try {
      return "Object(" + JSON.stringify(val) + ")";
    } catch (_) {
      return "Object";
    }
  }
  // errors
  if (val instanceof Error) {
    return `${val.name}: ${val.message}\n${val.stack}`;
  }
  // TODO we could test for more things here, like `Set`s and `Map`s.
  return className;
}

let stack_pointer = 128;

function addBorrowedObject(obj) {
  if (stack_pointer == 1) throw new Error("out of js stack");
  heap[--stack_pointer] = obj;
  return stack_pointer;
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptionSettingsError(error) {
  try {
    const ret = wasm.isEncryptionSettingsError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isCryptoError(error) {
  try {
    const ret = wasm.isCryptoError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

function getArrayU8FromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  return getUint8ArrayMemory0().subarray(ptr / 1, ptr / 1 + len);
}

function passArray8ToWasm0(arg, malloc) {
  const ptr = malloc(arg.length * 1, 1) >>> 0;
  getUint8ArrayMemory0().set(arg, ptr / 1);
  WASM_VECTOR_LEN = arg.length;
  return ptr;
}

function _assertClass(instance, klass) {
  if (!(instance instanceof klass)) {
    throw new Error(`expected instance of ${klass.name}`);
  }
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDeserializeError(error) {
  try {
    const ret = wasm.isDeserializeError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSshKeyExportError(error) {
  try {
    const ret = wasm.isSshKeyExportError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isSshKeyImportError(error) {
  try {
    const ret = wasm.isSshKeyImportError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isKeyGenerationError(error) {
  try {
    const ret = wasm.isKeyGenerationError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDecryptFileError(error) {
  try {
    const ret = wasm.isDecryptFileError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptFileError(error) {
  try {
    const ret = wasm.isEncryptFileError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isDecryptError(error) {
  try {
    const ret = wasm.isDecryptError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isEncryptError(error) {
  try {
    const ret = wasm.isEncryptError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {any} error
 * @returns {boolean}
 */
export function isTotpError(error) {
  try {
    const ret = wasm.isTotpError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

/**
 * @param {LogLevel} level
 */
export function set_log_level(level) {
  wasm.set_log_level(level);
}

/**
 * @param {LogLevel | null} [log_level]
 */
export function init_sdk(log_level) {
  wasm.init_sdk(isLikeNone(log_level) ? 5 : log_level);
}

/**
 * Generate a new SSH key pair
 *
 * # Arguments
 * - `key_algorithm` - The algorithm to use for the key pair
 *
 * # Returns
 * - `Ok(SshKey)` if the key was successfully generated
 * - `Err(KeyGenerationError)` if the key could not be generated
 * @param {KeyAlgorithm} key_algorithm
 * @returns {SshKeyView}
 */
export function generate_ssh_key(key_algorithm) {
  try {
    const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
    wasm.generate_ssh_key(retptr, addHeapObject(key_algorithm));
    var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
    var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
    var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
    if (r2) {
      throw takeObject(r1);
    }
    return takeObject(r0);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}

/**
 * Convert a PCKS8 or OpenSSH encrypted or unencrypted private key
 * to an OpenSSH private key with public key and fingerprint
 *
 * # Arguments
 * - `imported_key` - The private key to convert
 * - `password` - The password to use for decrypting the key
 *
 * # Returns
 * - `Ok(SshKey)` if the key was successfully coneverted
 * - `Err(PasswordRequired)` if the key is encrypted and no password was provided
 * - `Err(WrongPassword)` if the password provided is incorrect
 * - `Err(ParsingError)` if the key could not be parsed
 * - `Err(UnsupportedKeyType)` if the key type is not supported
 * @param {string} imported_key
 * @param {string | null} [password]
 * @returns {SshKeyView}
 */
export function import_ssh_key(imported_key, password) {
  try {
    const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
    const ptr0 = passStringToWasm0(imported_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(password)
      ? 0
      : passStringToWasm0(password, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    wasm.import_ssh_key(retptr, ptr0, len0, ptr1, len1);
    var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
    var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
    var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
    if (r2) {
      throw takeObject(r1);
    }
    return takeObject(r0);
  } finally {
    wasm.__wbindgen_add_to_stack_pointer(16);
  }
}

function passArrayJsValueToWasm0(array, malloc) {
  const ptr = malloc(array.length * 4, 4) >>> 0;
  const mem = getDataViewMemory0();
  for (let i = 0; i < array.length; i++) {
    mem.setUint32(ptr + 4 * i, addHeapObject(array[i]), true);
  }
  WASM_VECTOR_LEN = array.length;
  return ptr;
}

function getArrayJsValueFromWasm0(ptr, len) {
  ptr = ptr >>> 0;
  const mem = getDataViewMemory0();
  const result = [];
  for (let i = ptr; i < ptr + 4 * len; i += 4) {
    result.push(takeObject(mem.getUint32(i, true)));
  }
  return result;
}
/**
 * @param {any} error
 * @returns {boolean}
 */
export function isTestError(error) {
  try {
    const ret = wasm.isTestError(addBorrowedObject(error));
    return ret !== 0;
  } finally {
    heap[stack_pointer++] = undefined;
  }
}

function __wbg_adapter_50(arg0, arg1, arg2) {
  wasm._dyn_core__ops__function__FnMut__A____Output___R_as_wasm_bindgen__closure__WasmClosure___describe__invoke__h8ef26cc0e999965d(
    arg0,
    arg1,
    addHeapObject(arg2),
  );
}

function __wbg_adapter_215(arg0, arg1, arg2, arg3) {
  wasm.wasm_bindgen__convert__closures__invoke2_mut__h33defb2ea0fdb769(
    arg0,
    arg1,
    addHeapObject(arg2),
    addHeapObject(arg3),
  );
}

/**
 * @enum {300 | 301 | 302 | 303 | 304 | 305}
 */
export const CardLinkedIdType = Object.freeze({
  CardholderName: 300,
  300: "CardholderName",
  ExpMonth: 301,
  301: "ExpMonth",
  ExpYear: 302,
  302: "ExpYear",
  Code: 303,
  303: "Code",
  Brand: 304,
  304: "Brand",
  Number: 305,
  305: "Number",
});
/**
 * @enum {0 | 1}
 */
export const CipherRepromptType = Object.freeze({
  None: 0,
  0: "None",
  Password: 1,
  1: "Password",
});
/**
 * @enum {1 | 2 | 3 | 4 | 5}
 */
export const CipherType = Object.freeze({
  Login: 1,
  1: "Login",
  SecureNote: 2,
  2: "SecureNote",
  Card: 3,
  3: "Card",
  Identity: 4,
  4: "Identity",
  SshKey: 5,
  5: "SshKey",
});
/**
 * @enum {0 | 1 | 2 | 3}
 */
export const FieldType = Object.freeze({
  Text: 0,
  0: "Text",
  Hidden: 1,
  1: "Hidden",
  Boolean: 2,
  2: "Boolean",
  Linked: 3,
  3: "Linked",
});
/**
 * @enum {400 | 401 | 402 | 403 | 404 | 405 | 406 | 407 | 408 | 409 | 410 | 411 | 412 | 413 | 414 | 415 | 416 | 417 | 418}
 */
export const IdentityLinkedIdType = Object.freeze({
  Title: 400,
  400: "Title",
  MiddleName: 401,
  401: "MiddleName",
  Address1: 402,
  402: "Address1",
  Address2: 403,
  403: "Address2",
  Address3: 404,
  404: "Address3",
  City: 405,
  405: "City",
  State: 406,
  406: "State",
  PostalCode: 407,
  407: "PostalCode",
  Country: 408,
  408: "Country",
  Company: 409,
  409: "Company",
  Email: 410,
  410: "Email",
  Phone: 411,
  411: "Phone",
  Ssn: 412,
  412: "Ssn",
  Username: 413,
  413: "Username",
  PassportNumber: 414,
  414: "PassportNumber",
  LicenseNumber: 415,
  415: "LicenseNumber",
  FirstName: 416,
  416: "FirstName",
  LastName: 417,
  417: "LastName",
  FullName: 418,
  418: "FullName",
});
/**
 * @enum {0 | 1 | 2 | 3 | 4}
 */
export const LogLevel = Object.freeze({
  Trace: 0,
  0: "Trace",
  Debug: 1,
  1: "Debug",
  Info: 2,
  2: "Info",
  Warn: 3,
  3: "Warn",
  Error: 4,
  4: "Error",
});
/**
 * @enum {100 | 101}
 */
export const LoginLinkedIdType = Object.freeze({
  Username: 100,
  100: "Username",
  Password: 101,
  101: "Password",
});
/**
 * @enum {0}
 */
export const SecureNoteType = Object.freeze({
  Generic: 0,
  0: "Generic",
});
/**
 * @enum {0 | 1 | 2 | 3 | 4 | 5}
 */
export const UriMatchType = Object.freeze({
  Domain: 0,
  0: "Domain",
  Host: 1,
  1: "Host",
  StartsWith: 2,
  2: "StartsWith",
  Exact: 3,
  3: "Exact",
  RegularExpression: 4,
  4: "RegularExpression",
  Never: 5,
  5: "Never",
});

const __wbindgen_enum_RequestCredentials = ["omit", "same-origin", "include"];

const __wbindgen_enum_RequestMode = ["same-origin", "no-cors", "cors", "navigate"];

const BitwardenClientFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_bitwardenclient_free(ptr >>> 0, 1));

export class BitwardenClient {
  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    BitwardenClientFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_bitwardenclient_free(ptr, 0);
  }
  /**
   * @param {ClientSettings | null} [settings]
   */
  constructor(settings) {
    const ret = wasm.bitwardenclient_new(isLikeNone(settings) ? 0 : addHeapObject(settings));
    this.__wbg_ptr = ret >>> 0;
    BitwardenClientFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }
  /**
   * Test method, echoes back the input
   * @param {string} msg
   * @returns {string}
   */
  echo(msg) {
    let deferred2_0;
    let deferred2_1;
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(msg, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      wasm.bitwardenclient_echo(retptr, this.__wbg_ptr, ptr0, len0);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      deferred2_0 = r0;
      deferred2_1 = r1;
      return getStringFromWasm0(r0, r1);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
      wasm.__wbindgen_free(deferred2_0, deferred2_1, 1);
    }
  }
  /**
   * @returns {string}
   */
  version() {
    let deferred1_0;
    let deferred1_1;
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.bitwardenclient_version(retptr, this.__wbg_ptr);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      deferred1_0 = r0;
      deferred1_1 = r1;
      return getStringFromWasm0(r0, r1);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
      wasm.__wbindgen_free(deferred1_0, deferred1_1, 1);
    }
  }
  /**
   * @param {string} msg
   */
  throw(msg) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(msg, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      wasm.bitwardenclient_throw(retptr, this.__wbg_ptr, ptr0, len0);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      if (r1) {
        throw takeObject(r0);
      }
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * Test method, calls http endpoint
   * @param {string} url
   * @returns {Promise<string>}
   */
  http_get(url) {
    const ptr0 = passStringToWasm0(url, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    const len0 = WASM_VECTOR_LEN;
    const ret = wasm.bitwardenclient_http_get(this.__wbg_ptr, ptr0, len0);
    return takeObject(ret);
  }
  /**
   * @returns {CryptoClient}
   */
  crypto() {
    const ret = wasm.bitwardenclient_crypto(this.__wbg_ptr);
    return CryptoClient.__wrap(ret);
  }
  /**
   * @returns {VaultClient}
   */
  vault() {
    const ret = wasm.bitwardenclient_crypto(this.__wbg_ptr);
    return VaultClient.__wrap(ret);
  }
}

const ClientCiphersFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_clientciphers_free(ptr >>> 0, 1));

export class ClientCiphers {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(ClientCiphers.prototype);
    obj.__wbg_ptr = ptr;
    ClientCiphersFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    ClientCiphersFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_clientciphers_free(ptr, 0);
  }
  /**
   * Encrypt cipher
   *
   * # Arguments
   * - `cipher_view` - The decrypted cipher to encrypt
   *
   * # Returns
   * - `Ok(Cipher)` containing the encrypted cipher
   * - `Err(EncryptError)` if encryption fails
   * @param {CipherView} cipher_view
   * @returns {Cipher}
   */
  encrypt(cipher_view) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.clientciphers_encrypt(retptr, this.__wbg_ptr, addHeapObject(cipher_view));
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * Decrypt cipher
   *
   * # Arguments
   * - `cipher` - The encrypted cipher to decrypt
   *
   * # Returns
   * - `Ok(CipherView)` containing the decrypted cipher
   * - `Err(DecryptError)` if decryption fails
   * @param {Cipher} cipher
   * @returns {CipherView}
   */
  decrypt(cipher) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.clientciphers_decrypt(retptr, this.__wbg_ptr, addHeapObject(cipher));
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * Decrypt list of ciphers
   *
   * # Arguments
   * - `ciphers` - The list of encrypted ciphers to decrypt
   *
   * # Returns
   * - `Ok(Vec<CipherListView>)` containing the decrypted ciphers
   * - `Err(DecryptError)` if decryption fails
   * @param {Cipher[]} ciphers
   * @returns {CipherListView[]}
   */
  decrypt_list(ciphers) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passArrayJsValueToWasm0(ciphers, wasm.__wbindgen_malloc);
      const len0 = WASM_VECTOR_LEN;
      wasm.clientciphers_decrypt_list(retptr, this.__wbg_ptr, ptr0, len0);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      if (r3) {
        throw takeObject(r2);
      }
      var v2 = getArrayJsValueFromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 4, 4);
      return v2;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * Decrypt FIDO2 credentials
   *
   * # Arguments
   * - `cipher_view` - Cipher to encrypt containing the FIDO2 credential
   *
   * # Returns
   * - `Ok(Vec<Fido2CredentialView>)` containing the decrypted FIDO2 credentials
   * - `Err(DecryptError)` if decryption fails
   * @param {CipherView} cipher_view
   * @returns {Fido2CredentialView[]}
   */
  decrypt_fido2_credentials(cipher_view) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.clientciphers_decrypt_fido2_credentials(
        retptr,
        this.__wbg_ptr,
        addHeapObject(cipher_view),
      );
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      if (r3) {
        throw takeObject(r2);
      }
      var v1 = getArrayJsValueFromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 4, 4);
      return v1;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const ClientFoldersFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_clientfolders_free(ptr >>> 0, 1));

export class ClientFolders {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(ClientFolders.prototype);
    obj.__wbg_ptr = ptr;
    ClientFoldersFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    ClientFoldersFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_clientfolders_free(ptr, 0);
  }
  /**
   * Decrypt folder
   * @param {Folder} folder
   * @returns {FolderView}
   */
  decrypt(folder) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.clientfolders_decrypt(retptr, this.__wbg_ptr, addHeapObject(folder));
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const ClientTotpFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_clienttotp_free(ptr >>> 0, 1));

export class ClientTotp {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(ClientTotp.prototype);
    obj.__wbg_ptr = ptr;
    ClientTotpFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    ClientTotpFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_clienttotp_free(ptr, 0);
  }
  /**
   * Generates a TOTP code from a provided key
   *
   * # Arguments
   * - `key` - Can be:
   *     - A base32 encoded string
   *     - OTP Auth URI
   *     - Steam URI
   * - `time_ms` - Optional timestamp in milliseconds
   *
   * # Returns
   * - `Ok(TotpResponse)` containing the generated code and period
   * - `Err(TotpError)` if code generation fails
   * @param {string} key
   * @param {number | null} [time_ms]
   * @returns {TotpResponse}
   */
  generate_totp(key, time_ms) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      wasm.clienttotp_generate_totp(
        retptr,
        this.__wbg_ptr,
        ptr0,
        len0,
        !isLikeNone(time_ms),
        isLikeNone(time_ms) ? 0 : time_ms,
      );
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const CryptoClientFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_cryptoclient_free(ptr >>> 0, 1));

export class CryptoClient {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(CryptoClient.prototype);
    obj.__wbg_ptr = ptr;
    CryptoClientFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    CryptoClientFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_cryptoclient_free(ptr, 0);
  }
  /**
   * Initialization method for the user crypto. Needs to be called before any other crypto
   * operations.
   * @param {InitUserCryptoRequest} req
   * @returns {Promise<void>}
   */
  initialize_user_crypto(req) {
    const ret = wasm.cryptoclient_initialize_user_crypto(this.__wbg_ptr, addHeapObject(req));
    return takeObject(ret);
  }
  /**
   * Initialization method for the organization crypto. Needs to be called after
   * `initialize_user_crypto` but before any other crypto operations.
   * @param {InitOrgCryptoRequest} req
   * @returns {Promise<void>}
   */
  initialize_org_crypto(req) {
    const ret = wasm.cryptoclient_initialize_org_crypto(this.__wbg_ptr, addHeapObject(req));
    return takeObject(ret);
  }
  /**
   * Generates a new key pair and encrypts the private key with the provided user key.
   * Crypto initialization not required.
   * @param {string} user_key
   * @returns {MakeKeyPairResponse}
   */
  make_key_pair(user_key) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(user_key, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      wasm.cryptoclient_make_key_pair(retptr, this.__wbg_ptr, ptr0, len0);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * Verifies a user's asymmetric keys by decrypting the private key with the provided user
   * key. Returns if the private key is decryptable and if it is a valid matching key.
   * Crypto initialization not required.
   * @param {VerifyAsymmetricKeysRequest} request
   * @returns {VerifyAsymmetricKeysResponse}
   */
  verify_asymmetric_keys(request) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.cryptoclient_verify_asymmetric_keys(retptr, this.__wbg_ptr, addHeapObject(request));
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return takeObject(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const IncomingMessageFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_incomingmessage_free(ptr >>> 0, 1));

export class IncomingMessage {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(IncomingMessage.prototype);
    obj.__wbg_ptr = ptr;
    IncomingMessageFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    IncomingMessageFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_incomingmessage_free(ptr, 0);
  }
  /**
   * @returns {Uint8Array}
   */
  get payload() {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_incomingmessage_payload(retptr, this.__wbg_ptr);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var v1 = getArrayU8FromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 1, 1);
      return v1;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {Uint8Array} arg0
   */
  set payload(arg0) {
    const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.__wbg_set_incomingmessage_payload(this.__wbg_ptr, ptr0, len0);
  }
  /**
   * @returns {Endpoint}
   */
  get destination() {
    const ret = wasm.__wbg_get_incomingmessage_destination(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {Endpoint} arg0
   */
  set destination(arg0) {
    wasm.__wbg_set_incomingmessage_destination(this.__wbg_ptr, addHeapObject(arg0));
  }
  /**
   * @returns {Endpoint}
   */
  get source() {
    const ret = wasm.__wbg_get_incomingmessage_source(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {Endpoint} arg0
   */
  set source(arg0) {
    wasm.__wbg_set_incomingmessage_source(this.__wbg_ptr, addHeapObject(arg0));
  }
  /**
   * @returns {string | undefined}
   */
  get topic() {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_incomingmessage_topic(retptr, this.__wbg_ptr);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      let v1;
      if (r0 !== 0) {
        v1 = getStringFromWasm0(r0, r1).slice();
        wasm.__wbindgen_free(r0, r1 * 1, 1);
      }
      return v1;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {string | null} [arg0]
   */
  set topic(arg0) {
    var ptr0 = isLikeNone(arg0)
      ? 0
      : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.__wbg_set_incomingmessage_topic(this.__wbg_ptr, ptr0, len0);
  }
  /**
   * @param {Uint8Array} payload
   * @param {Endpoint} destination
   * @param {Endpoint} source
   * @param {string | null} [topic]
   */
  constructor(payload, destination, source, topic) {
    const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(topic)
      ? 0
      : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.incomingmessage_new(
      ptr0,
      len0,
      addHeapObject(destination),
      addHeapObject(source),
      ptr1,
      len1,
    );
    this.__wbg_ptr = ret >>> 0;
    IncomingMessageFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }
  /**
   * Try to parse the payload as JSON.
   * @returns {any} The parsed JSON value, or undefined if the payload is not valid JSON.
   */
  parse_payload_as_json() {
    const ret = wasm.incomingmessage_parse_payload_as_json(this.__wbg_ptr);
    return takeObject(ret);
  }
}

const IpcClientFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_ipcclient_free(ptr >>> 0, 1));

export class IpcClient {
  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    IpcClientFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_ipcclient_free(ptr, 0);
  }
  /**
   * @param {CommunicationBackend} communication_provider
   */
  constructor(communication_provider) {
    const ret = wasm.ipcclient_new(addHeapObject(communication_provider));
    this.__wbg_ptr = ret >>> 0;
    IpcClientFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }
  /**
   * @param {OutgoingMessage} message
   * @returns {Promise<void>}
   */
  send(message) {
    _assertClass(message, OutgoingMessage);
    var ptr0 = message.__destroy_into_raw();
    const ret = wasm.ipcclient_send(this.__wbg_ptr, ptr0);
    return takeObject(ret);
  }
  /**
   * @returns {Promise<IncomingMessage>}
   */
  receive() {
    const ret = wasm.ipcclient_receive(this.__wbg_ptr);
    return takeObject(ret);
  }
}

const OutgoingMessageFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_outgoingmessage_free(ptr >>> 0, 1));

export class OutgoingMessage {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(OutgoingMessage.prototype);
    obj.__wbg_ptr = ptr;
    OutgoingMessageFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    OutgoingMessageFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_outgoingmessage_free(ptr, 0);
  }
  /**
   * @returns {Uint8Array}
   */
  get payload() {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_outgoingmessage_payload(retptr, this.__wbg_ptr);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var v1 = getArrayU8FromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 1, 1);
      return v1;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {Uint8Array} arg0
   */
  set payload(arg0) {
    const ptr0 = passArray8ToWasm0(arg0, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    wasm.__wbg_set_outgoingmessage_payload(this.__wbg_ptr, ptr0, len0);
  }
  /**
   * @returns {Endpoint}
   */
  get destination() {
    const ret = wasm.__wbg_get_incomingmessage_destination(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {Endpoint} arg0
   */
  set destination(arg0) {
    wasm.__wbg_set_incomingmessage_destination(this.__wbg_ptr, addHeapObject(arg0));
  }
  /**
   * @returns {string | undefined}
   */
  get topic() {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      wasm.__wbg_get_outgoingmessage_topic(retptr, this.__wbg_ptr);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      let v1;
      if (r0 !== 0) {
        v1 = getStringFromWasm0(r0, r1).slice();
        wasm.__wbindgen_free(r0, r1 * 1, 1);
      }
      return v1;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {string | null} [arg0]
   */
  set topic(arg0) {
    var ptr0 = isLikeNone(arg0)
      ? 0
      : passStringToWasm0(arg0, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len0 = WASM_VECTOR_LEN;
    wasm.__wbg_set_outgoingmessage_topic(this.__wbg_ptr, ptr0, len0);
  }
  /**
   * @param {Uint8Array} payload
   * @param {Endpoint} destination
   * @param {string | null} [topic]
   */
  constructor(payload, destination, topic) {
    const ptr0 = passArray8ToWasm0(payload, wasm.__wbindgen_malloc);
    const len0 = WASM_VECTOR_LEN;
    var ptr1 = isLikeNone(topic)
      ? 0
      : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
    var len1 = WASM_VECTOR_LEN;
    const ret = wasm.outgoingmessage_new(ptr0, len0, addHeapObject(destination), ptr1, len1);
    this.__wbg_ptr = ret >>> 0;
    OutgoingMessageFinalization.register(this, this.__wbg_ptr, this);
    return this;
  }
  /**
   * Create a new message and encode the payload as JSON.
   * @param {any} payload
   * @param {Endpoint} destination
   * @param {string | null} [topic]
   * @returns {OutgoingMessage}
   */
  static new_json_payload(payload, destination, topic) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      var ptr0 = isLikeNone(topic)
        ? 0
        : passStringToWasm0(topic, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      var len0 = WASM_VECTOR_LEN;
      wasm.outgoingmessage_new_json_payload(
        retptr,
        addHeapObject(payload),
        addHeapObject(destination),
        ptr0,
        len0,
      );
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      if (r2) {
        throw takeObject(r1);
      }
      return OutgoingMessage.__wrap(r0);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const PureCryptoFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_purecrypto_free(ptr >>> 0, 1));
/**
 * This module represents a stopgap solution to provide access to primitive crypto functions for JS
 * clients. It is not intended to be used outside of the JS clients and this pattern should not be
 * proliferated. It is necessary because we want to use SDK crypto prior to the SDK being fully
 * responsible for state and keys.
 */
export class PureCrypto {
  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    PureCryptoFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_purecrypto_free(ptr, 0);
  }
  /**
   * @param {string} enc_string
   * @param {Uint8Array} key
   * @returns {string}
   */
  static symmetric_decrypt(enc_string, key) {
    let deferred4_0;
    let deferred4_1;
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(enc_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      const len1 = WASM_VECTOR_LEN;
      wasm.purecrypto_symmetric_decrypt(retptr, ptr0, len0, ptr1, len1);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      var ptr3 = r0;
      var len3 = r1;
      if (r3) {
        ptr3 = 0;
        len3 = 0;
        throw takeObject(r2);
      }
      deferred4_0 = ptr3;
      deferred4_1 = len3;
      return getStringFromWasm0(ptr3, len3);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
      wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
  }
  /**
   * @param {string} enc_string
   * @param {Uint8Array} key
   * @returns {Uint8Array}
   */
  static symmetric_decrypt_to_bytes(enc_string, key) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(enc_string, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      const len1 = WASM_VECTOR_LEN;
      wasm.purecrypto_symmetric_decrypt_to_bytes(retptr, ptr0, len0, ptr1, len1);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      if (r3) {
        throw takeObject(r2);
      }
      var v3 = getArrayU8FromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 1, 1);
      return v3;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {Uint8Array} enc_bytes
   * @param {Uint8Array} key
   * @returns {Uint8Array}
   */
  static symmetric_decrypt_array_buffer(enc_bytes, key) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passArray8ToWasm0(enc_bytes, wasm.__wbindgen_malloc);
      const len0 = WASM_VECTOR_LEN;
      const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      const len1 = WASM_VECTOR_LEN;
      wasm.purecrypto_symmetric_decrypt_array_buffer(retptr, ptr0, len0, ptr1, len1);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      if (r3) {
        throw takeObject(r2);
      }
      var v3 = getArrayU8FromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 1, 1);
      return v3;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
  /**
   * @param {string} plain
   * @param {Uint8Array} key
   * @returns {string}
   */
  static symmetric_encrypt(plain, key) {
    let deferred4_0;
    let deferred4_1;
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passStringToWasm0(plain, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
      const len0 = WASM_VECTOR_LEN;
      const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      const len1 = WASM_VECTOR_LEN;
      wasm.purecrypto_symmetric_encrypt(retptr, ptr0, len0, ptr1, len1);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      var ptr3 = r0;
      var len3 = r1;
      if (r3) {
        ptr3 = 0;
        len3 = 0;
        throw takeObject(r2);
      }
      deferred4_0 = ptr3;
      deferred4_1 = len3;
      return getStringFromWasm0(ptr3, len3);
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
      wasm.__wbindgen_free(deferred4_0, deferred4_1, 1);
    }
  }
  /**
   * @param {Uint8Array} plain
   * @param {Uint8Array} key
   * @returns {Uint8Array}
   */
  static symmetric_encrypt_to_array_buffer(plain, key) {
    try {
      const retptr = wasm.__wbindgen_add_to_stack_pointer(-16);
      const ptr0 = passArray8ToWasm0(plain, wasm.__wbindgen_malloc);
      const len0 = WASM_VECTOR_LEN;
      const ptr1 = passArray8ToWasm0(key, wasm.__wbindgen_malloc);
      const len1 = WASM_VECTOR_LEN;
      wasm.purecrypto_symmetric_encrypt_to_array_buffer(retptr, ptr0, len0, ptr1, len1);
      var r0 = getDataViewMemory0().getInt32(retptr + 4 * 0, true);
      var r1 = getDataViewMemory0().getInt32(retptr + 4 * 1, true);
      var r2 = getDataViewMemory0().getInt32(retptr + 4 * 2, true);
      var r3 = getDataViewMemory0().getInt32(retptr + 4 * 3, true);
      if (r3) {
        throw takeObject(r2);
      }
      var v3 = getArrayU8FromWasm0(r0, r1).slice();
      wasm.__wbindgen_free(r0, r1 * 1, 1);
      return v3;
    } finally {
      wasm.__wbindgen_add_to_stack_pointer(16);
    }
  }
}

const ReceiveErrorFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_receiveerror_free(ptr >>> 0, 1));

export class ReceiveError {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(ReceiveError.prototype);
    obj.__wbg_ptr = ptr;
    ReceiveErrorFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    ReceiveErrorFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_receiveerror_free(ptr, 0);
  }
  /**
   * @returns {boolean}
   */
  get timeout() {
    const ret = wasm.__wbg_get_receiveerror_timeout(this.__wbg_ptr);
    return ret !== 0;
  }
  /**
   * @param {boolean} arg0
   */
  set timeout(arg0) {
    wasm.__wbg_set_receiveerror_timeout(this.__wbg_ptr, arg0);
  }
  /**
   * @returns {any}
   */
  get crypto() {
    const ret = wasm.__wbg_get_receiveerror_crypto(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {any} arg0
   */
  set crypto(arg0) {
    wasm.__wbg_set_receiveerror_crypto(this.__wbg_ptr, addHeapObject(arg0));
  }
  /**
   * @returns {any}
   */
  get communication() {
    const ret = wasm.__wbg_get_receiveerror_communication(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {any} arg0
   */
  set communication(arg0) {
    wasm.__wbg_set_receiveerror_communication(this.__wbg_ptr, addHeapObject(arg0));
  }
}

const SendErrorFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_senderror_free(ptr >>> 0, 1));

export class SendError {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(SendError.prototype);
    obj.__wbg_ptr = ptr;
    SendErrorFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    SendErrorFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_senderror_free(ptr, 0);
  }
  /**
   * @returns {any}
   */
  get crypto() {
    const ret = wasm.__wbg_get_receiveerror_crypto(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {any} arg0
   */
  set crypto(arg0) {
    wasm.__wbg_set_receiveerror_crypto(this.__wbg_ptr, addHeapObject(arg0));
  }
  /**
   * @returns {any}
   */
  get communication() {
    const ret = wasm.__wbg_get_receiveerror_communication(this.__wbg_ptr);
    return takeObject(ret);
  }
  /**
   * @param {any} arg0
   */
  set communication(arg0) {
    wasm.__wbg_set_receiveerror_communication(this.__wbg_ptr, addHeapObject(arg0));
  }
}

const VaultClientFinalization =
  typeof FinalizationRegistry === "undefined"
    ? { register: () => {}, unregister: () => {} }
    : new FinalizationRegistry((ptr) => wasm.__wbg_vaultclient_free(ptr >>> 0, 1));

export class VaultClient {
  static __wrap(ptr) {
    ptr = ptr >>> 0;
    const obj = Object.create(VaultClient.prototype);
    obj.__wbg_ptr = ptr;
    VaultClientFinalization.register(obj, obj.__wbg_ptr, obj);
    return obj;
  }

  __destroy_into_raw() {
    const ptr = this.__wbg_ptr;
    this.__wbg_ptr = 0;
    VaultClientFinalization.unregister(this);
    return ptr;
  }

  free() {
    const ptr = this.__destroy_into_raw();
    wasm.__wbg_vaultclient_free(ptr, 0);
  }
  /**
   * @returns {ClientCiphers}
   */
  ciphers() {
    const ret = wasm.bitwardenclient_crypto(this.__wbg_ptr);
    return ClientCiphers.__wrap(ret);
  }
  /**
   * @returns {ClientFolders}
   */
  folders() {
    const ret = wasm.bitwardenclient_crypto(this.__wbg_ptr);
    return ClientFolders.__wrap(ret);
  }
  /**
   * @returns {ClientTotp}
   */
  totp() {
    const ret = wasm.bitwardenclient_crypto(this.__wbg_ptr);
    return ClientTotp.__wrap(ret);
  }
}

export function __wbg_String_8f0eb39a4a4c2f66(arg0, arg1) {
  const ret = String(getObject(arg1));
  const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  const len1 = WASM_VECTOR_LEN;
  getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}

export function __wbg_abort_775ef1d17fc65868(arg0) {
  getObject(arg0).abort();
}

export function __wbg_append_299d5d48292c0495() {
  return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
  }, arguments);
}

export function __wbg_append_8c7dd8d641a5f01b() {
  return handleError(function (arg0, arg1, arg2, arg3, arg4) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getStringFromWasm0(arg3, arg4));
  }, arguments);
}

export function __wbg_append_b2d1fc16de2a0e81() {
  return handleError(function (arg0, arg1, arg2, arg3, arg4, arg5) {
    getObject(arg0).append(
      getStringFromWasm0(arg1, arg2),
      getObject(arg3),
      getStringFromWasm0(arg4, arg5),
    );
  }, arguments);
}

export function __wbg_append_b44785ebeb668479() {
  return handleError(function (arg0, arg1, arg2, arg3) {
    getObject(arg0).append(getStringFromWasm0(arg1, arg2), getObject(arg3));
  }, arguments);
}

export function __wbg_buffer_609cc3eee51ed158(arg0) {
  const ret = getObject(arg0).buffer;
  return addHeapObject(ret);
}

export function __wbg_call_672a4d21634d4a24() {
  return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).call(getObject(arg1));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_call_7cccdd69e0791ae2() {
  return handleError(function (arg0, arg1, arg2) {
    const ret = getObject(arg0).call(getObject(arg1), getObject(arg2));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_crypto_ed58b8e10a292839(arg0) {
  const ret = getObject(arg0).crypto;
  return addHeapObject(ret);
}

export function __wbg_debug_e17b51583ca6a632(arg0, arg1, arg2, arg3) {
  console.debug(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
}

export function __wbg_done_769e5ede4b31c67b(arg0) {
  const ret = getObject(arg0).done;
  return ret;
}

export function __wbg_entries_3265d4158b33e5dc(arg0) {
  const ret = Object.entries(getObject(arg0));
  return addHeapObject(ret);
}

export function __wbg_error_7534b8e9a36f1ab4(arg0, arg1) {
  let deferred0_0;
  let deferred0_1;
  try {
    deferred0_0 = arg0;
    deferred0_1 = arg1;
    console.error(getStringFromWasm0(arg0, arg1));
  } finally {
    wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
  }
}

export function __wbg_error_80de38b3f7cc3c3c(arg0, arg1, arg2, arg3) {
  console.error(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
}

export function __wbg_fetch_4465c2b10f21a927(arg0) {
  const ret = fetch(getObject(arg0));
  return addHeapObject(ret);
}

export function __wbg_fetch_509096533071c657(arg0, arg1) {
  const ret = getObject(arg0).fetch(getObject(arg1));
  return addHeapObject(ret);
}

export function __wbg_getRandomValues_bcb4912f16000dc4() {
  return handleError(function (arg0, arg1) {
    getObject(arg0).getRandomValues(getObject(arg1));
  }, arguments);
}

export function __wbg_getTime_46267b1c24877e30(arg0) {
  const ret = getObject(arg0).getTime();
  return ret;
}

export function __wbg_get_67b2ba62fc30de12() {
  return handleError(function (arg0, arg1) {
    const ret = Reflect.get(getObject(arg0), getObject(arg1));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_get_b9b93047fe3cf45b(arg0, arg1) {
  const ret = getObject(arg0)[arg1 >>> 0];
  return addHeapObject(ret);
}

export function __wbg_getwithrefkey_1dc361bd10053bfe(arg0, arg1) {
  const ret = getObject(arg0)[getObject(arg1)];
  return addHeapObject(ret);
}

export function __wbg_has_a5ea9117f258a0ec() {
  return handleError(function (arg0, arg1) {
    const ret = Reflect.has(getObject(arg0), getObject(arg1));
    return ret;
  }, arguments);
}

export function __wbg_headers_9cb51cfd2ac780a4(arg0) {
  const ret = getObject(arg0).headers;
  return addHeapObject(ret);
}

export function __wbg_incomingmessage_new(arg0) {
  const ret = IncomingMessage.__wrap(arg0);
  return addHeapObject(ret);
}

export function __wbg_info_033d8b8a0838f1d3(arg0, arg1, arg2, arg3) {
  console.info(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
}

export function __wbg_instanceof_ArrayBuffer_e14585432e3737fc(arg0) {
  let result;
  try {
    result = getObject(arg0) instanceof ArrayBuffer;
  } catch (_) {
    result = false;
  }
  const ret = result;
  return ret;
}

export function __wbg_instanceof_Map_f3469ce2244d2430(arg0) {
  let result;
  try {
    result = getObject(arg0) instanceof Map;
  } catch (_) {
    result = false;
  }
  const ret = result;
  return ret;
}

export function __wbg_instanceof_Response_f2cc20d9f7dfd644(arg0) {
  let result;
  try {
    result = getObject(arg0) instanceof Response;
  } catch (_) {
    result = false;
  }
  const ret = result;
  return ret;
}

export function __wbg_instanceof_Uint8Array_17156bcf118086a9(arg0) {
  let result;
  try {
    result = getObject(arg0) instanceof Uint8Array;
  } catch (_) {
    result = false;
  }
  const ret = result;
  return ret;
}

export function __wbg_isArray_a1eab7e0d067391b(arg0) {
  const ret = Array.isArray(getObject(arg0));
  return ret;
}

export function __wbg_isSafeInteger_343e2beeeece1bb0(arg0) {
  const ret = Number.isSafeInteger(getObject(arg0));
  return ret;
}

export function __wbg_iterator_9a24c88df860dc65() {
  const ret = Symbol.iterator;
  return addHeapObject(ret);
}

export function __wbg_length_a446193dc22c12f8(arg0) {
  const ret = getObject(arg0).length;
  return ret;
}

export function __wbg_length_e2d2a49132c1b256(arg0) {
  const ret = getObject(arg0).length;
  return ret;
}

export function __wbg_log_cad59bb680daec67(arg0, arg1, arg2, arg3) {
  console.log(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
}

export function __wbg_msCrypto_0a36e2ec3a343d26(arg0) {
  const ret = getObject(arg0).msCrypto;
  return addHeapObject(ret);
}

export function __wbg_new0_f788a2397c7ca929() {
  const ret = new Date();
  return addHeapObject(ret);
}

export function __wbg_new_018dcc2d6c8c2f6a() {
  return handleError(function () {
    const ret = new Headers();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_new_23a2665fac83c611(arg0, arg1) {
  try {
    var state0 = { a: arg0, b: arg1 };
    var cb0 = (arg0, arg1) => {
      const a = state0.a;
      state0.a = 0;
      try {
        return __wbg_adapter_215(a, state0.b, arg0, arg1);
      } finally {
        state0.a = a;
      }
    };
    const ret = new Promise(cb0);
    return addHeapObject(ret);
  } finally {
    state0.a = state0.b = 0;
  }
}

export function __wbg_new_405e22f390576ce2() {
  const ret = new Object();
  return addHeapObject(ret);
}

export function __wbg_new_78feb108b6472713() {
  const ret = new Array();
  return addHeapObject(ret);
}

export function __wbg_new_8a6f238a6ece86ea() {
  const ret = new Error();
  return addHeapObject(ret);
}

export function __wbg_new_9fd39a253424609a() {
  return handleError(function () {
    const ret = new FormData();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_new_a12002a7f91c75be(arg0) {
  const ret = new Uint8Array(getObject(arg0));
  return addHeapObject(ret);
}

export function __wbg_new_c68d7209be747379(arg0, arg1) {
  const ret = new Error(getStringFromWasm0(arg0, arg1));
  return addHeapObject(ret);
}

export function __wbg_new_e25e5aab09ff45db() {
  return handleError(function () {
    const ret = new AbortController();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_new_f24b6d53abe5bc82(arg0, arg1) {
  let deferred0_0;
  let deferred0_1;
  try {
    deferred0_0 = arg0;
    deferred0_1 = arg1;
    const ret = new Error(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
  } finally {
    wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
  }
}

export function __wbg_newnoargs_105ed471475aaf50(arg0, arg1) {
  const ret = new Function(getStringFromWasm0(arg0, arg1));
  return addHeapObject(ret);
}

export function __wbg_newwithbyteoffsetandlength_d97e637ebe145a9a(arg0, arg1, arg2) {
  const ret = new Uint8Array(getObject(arg0), arg1 >>> 0, arg2 >>> 0);
  return addHeapObject(ret);
}

export function __wbg_newwithlength_a381634e90c276d4(arg0) {
  const ret = new Uint8Array(arg0 >>> 0);
  return addHeapObject(ret);
}

export function __wbg_newwithstrandinit_06c535e0a867c635() {
  return handleError(function (arg0, arg1, arg2) {
    const ret = new Request(getStringFromWasm0(arg0, arg1), getObject(arg2));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_newwithu8arraysequenceandoptions_068570c487f69127() {
  return handleError(function (arg0, arg1) {
    const ret = new Blob(getObject(arg0), getObject(arg1));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_next_25feadfc0913fea9(arg0) {
  const ret = getObject(arg0).next;
  return addHeapObject(ret);
}

export function __wbg_next_6574e1a8a62d1055() {
  return handleError(function (arg0) {
    const ret = getObject(arg0).next();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_node_02999533c4ea02e3(arg0) {
  const ret = getObject(arg0).node;
  return addHeapObject(ret);
}

export function __wbg_parse_def2e24ef1252aff() {
  return handleError(function (arg0, arg1) {
    const ret = JSON.parse(getStringFromWasm0(arg0, arg1));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_process_5c1d670bc53614b8(arg0) {
  const ret = getObject(arg0).process;
  return addHeapObject(ret);
}

export function __wbg_push_737cfc8c1432c2c6(arg0, arg1) {
  const ret = getObject(arg0).push(getObject(arg1));
  return ret;
}

export function __wbg_queueMicrotask_97d92b4fcc8a61c5(arg0) {
  queueMicrotask(getObject(arg0));
}

export function __wbg_queueMicrotask_d3219def82552485(arg0) {
  const ret = getObject(arg0).queueMicrotask;
  return addHeapObject(ret);
}

export function __wbg_randomFillSync_ab2cfe79ebbf2740() {
  return handleError(function (arg0, arg1) {
    getObject(arg0).randomFillSync(takeObject(arg1));
  }, arguments);
}

export function __wbg_receive_9512d555fb8b5130() {
  return handleError(function (arg0) {
    const ret = getObject(arg0).receive();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_receiveerror_new(arg0) {
  const ret = ReceiveError.__wrap(arg0);
  return addHeapObject(ret);
}

export function __wbg_require_79b1e9274cde3c87() {
  return handleError(function () {
    const ret = module.require;
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_resolve_4851785c9c5f573d(arg0) {
  const ret = Promise.resolve(getObject(arg0));
  return addHeapObject(ret);
}

export function __wbg_send_c9eacaae08065b18() {
  return handleError(function (arg0, arg1) {
    const ret = getObject(arg0).send(OutgoingMessage.__wrap(arg1));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_senderror_new(arg0) {
  const ret = SendError.__wrap(arg0);
  return addHeapObject(ret);
}

export function __wbg_set_37837023f3d740e8(arg0, arg1, arg2) {
  getObject(arg0)[arg1 >>> 0] = takeObject(arg2);
}

export function __wbg_set_3f1d0b984ed272ed(arg0, arg1, arg2) {
  getObject(arg0)[takeObject(arg1)] = takeObject(arg2);
}

export function __wbg_set_65595bdd868b3009(arg0, arg1, arg2) {
  getObject(arg0).set(getObject(arg1), arg2 >>> 0);
}

export function __wbg_setbody_5923b78a95eedf29(arg0, arg1) {
  getObject(arg0).body = getObject(arg1);
}

export function __wbg_setcredentials_c3a22f1cd105a2c6(arg0, arg1) {
  getObject(arg0).credentials = __wbindgen_enum_RequestCredentials[arg1];
}

export function __wbg_setheaders_834c0bdb6a8949ad(arg0, arg1) {
  getObject(arg0).headers = getObject(arg1);
}

export function __wbg_setmethod_3c5280fe5d890842(arg0, arg1, arg2) {
  getObject(arg0).method = getStringFromWasm0(arg1, arg2);
}

export function __wbg_setmode_5dc300b865044b65(arg0, arg1) {
  getObject(arg0).mode = __wbindgen_enum_RequestMode[arg1];
}

export function __wbg_setname_c0e2d6f348c746f4(arg0, arg1, arg2) {
  let deferred0_0;
  let deferred0_1;
  try {
    deferred0_0 = arg1;
    deferred0_1 = arg2;
    getObject(arg0).name = getStringFromWasm0(arg1, arg2);
  } finally {
    wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
  }
}

export function __wbg_setsignal_75b21ef3a81de905(arg0, arg1) {
  getObject(arg0).signal = getObject(arg1);
}

export function __wbg_settype_39ed370d3edd403c(arg0, arg1, arg2) {
  getObject(arg0).type = getStringFromWasm0(arg1, arg2);
}

export function __wbg_setvariant_d1d41b778dfe9c17(arg0, arg1, arg2) {
  let deferred0_0;
  let deferred0_1;
  try {
    deferred0_0 = arg1;
    deferred0_1 = arg2;
    getObject(arg0).variant = getStringFromWasm0(arg1, arg2);
  } finally {
    wasm.__wbindgen_free(deferred0_0, deferred0_1, 1);
  }
}

export function __wbg_signal_aaf9ad74119f20a4(arg0) {
  const ret = getObject(arg0).signal;
  return addHeapObject(ret);
}

export function __wbg_stack_0ed75d68575b0f3c(arg0, arg1) {
  const ret = getObject(arg1).stack;
  const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  const len1 = WASM_VECTOR_LEN;
  getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}

export function __wbg_static_accessor_GLOBAL_88a902d13a557d07() {
  const ret = typeof global === "undefined" ? null : global;
  return isLikeNone(ret) ? 0 : addHeapObject(ret);
}

export function __wbg_static_accessor_GLOBAL_THIS_56578be7e9f832b0() {
  const ret = typeof globalThis === "undefined" ? null : globalThis;
  return isLikeNone(ret) ? 0 : addHeapObject(ret);
}

export function __wbg_static_accessor_SELF_37c5d418e4bf5819() {
  const ret = typeof self === "undefined" ? null : self;
  return isLikeNone(ret) ? 0 : addHeapObject(ret);
}

export function __wbg_static_accessor_WINDOW_5de37043a91a9c40() {
  const ret = typeof window === "undefined" ? null : window;
  return isLikeNone(ret) ? 0 : addHeapObject(ret);
}

export function __wbg_status_f6360336ca686bf0(arg0) {
  const ret = getObject(arg0).status;
  return ret;
}

export function __wbg_stringify_f7ed6987935b4a24() {
  return handleError(function (arg0) {
    const ret = JSON.stringify(getObject(arg0));
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_subarray_aa9065fa9dc5df96(arg0, arg1, arg2) {
  const ret = getObject(arg0).subarray(arg1 >>> 0, arg2 >>> 0);
  return addHeapObject(ret);
}

export function __wbg_text_7805bea50de2af49() {
  return handleError(function (arg0) {
    const ret = getObject(arg0).text();
    return addHeapObject(ret);
  }, arguments);
}

export function __wbg_then_44b73946d2fb3e7d(arg0, arg1) {
  const ret = getObject(arg0).then(getObject(arg1));
  return addHeapObject(ret);
}

export function __wbg_then_48b406749878a531(arg0, arg1, arg2) {
  const ret = getObject(arg0).then(getObject(arg1), getObject(arg2));
  return addHeapObject(ret);
}

export function __wbg_url_ae10c34ca209681d(arg0, arg1) {
  const ret = getObject(arg1).url;
  const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  const len1 = WASM_VECTOR_LEN;
  getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}

export function __wbg_value_cd1ffa7b1ab794f1(arg0) {
  const ret = getObject(arg0).value;
  return addHeapObject(ret);
}

export function __wbg_versions_c71aa1626a93e0a1(arg0) {
  const ret = getObject(arg0).versions;
  return addHeapObject(ret);
}

export function __wbg_warn_aaf1f4664a035bd6(arg0, arg1, arg2, arg3) {
  console.warn(getObject(arg0), getObject(arg1), getObject(arg2), getObject(arg3));
}

export function __wbindgen_as_number(arg0) {
  const ret = +getObject(arg0);
  return ret;
}

export function __wbindgen_bigint_from_i64(arg0) {
  const ret = arg0;
  return addHeapObject(ret);
}

export function __wbindgen_bigint_from_u64(arg0) {
  const ret = BigInt.asUintN(64, arg0);
  return addHeapObject(ret);
}

export function __wbindgen_bigint_get_as_i64(arg0, arg1) {
  const v = getObject(arg1);
  const ret = typeof v === "bigint" ? v : undefined;
  getDataViewMemory0().setBigInt64(arg0 + 8 * 1, isLikeNone(ret) ? BigInt(0) : ret, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
}

export function __wbindgen_boolean_get(arg0) {
  const v = getObject(arg0);
  const ret = typeof v === "boolean" ? (v ? 1 : 0) : 2;
  return ret;
}

export function __wbindgen_cb_drop(arg0) {
  const obj = takeObject(arg0).original;
  if (obj.cnt-- == 1) {
    obj.a = 0;
    return true;
  }
  const ret = false;
  return ret;
}

export function __wbindgen_closure_wrapper2552(arg0, arg1, arg2) {
  const ret = makeMutClosure(arg0, arg1, 634, __wbg_adapter_50);
  return addHeapObject(ret);
}

export function __wbindgen_debug_string(arg0, arg1) {
  const ret = debugString(getObject(arg1));
  const ptr1 = passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  const len1 = WASM_VECTOR_LEN;
  getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}

export function __wbindgen_error_new(arg0, arg1) {
  const ret = new Error(getStringFromWasm0(arg0, arg1));
  return addHeapObject(ret);
}

export function __wbindgen_in(arg0, arg1) {
  const ret = getObject(arg0) in getObject(arg1);
  return ret;
}

export function __wbindgen_is_bigint(arg0) {
  const ret = typeof getObject(arg0) === "bigint";
  return ret;
}

export function __wbindgen_is_function(arg0) {
  const ret = typeof getObject(arg0) === "function";
  return ret;
}

export function __wbindgen_is_object(arg0) {
  const val = getObject(arg0);
  const ret = typeof val === "object" && val !== null;
  return ret;
}

export function __wbindgen_is_string(arg0) {
  const ret = typeof getObject(arg0) === "string";
  return ret;
}

export function __wbindgen_is_undefined(arg0) {
  const ret = getObject(arg0) === undefined;
  return ret;
}

export function __wbindgen_jsval_eq(arg0, arg1) {
  const ret = getObject(arg0) === getObject(arg1);
  return ret;
}

export function __wbindgen_jsval_loose_eq(arg0, arg1) {
  const ret = getObject(arg0) == getObject(arg1);
  return ret;
}

export function __wbindgen_memory() {
  const ret = wasm.memory;
  return addHeapObject(ret);
}

export function __wbindgen_number_get(arg0, arg1) {
  const obj = getObject(arg1);
  const ret = typeof obj === "number" ? obj : undefined;
  getDataViewMemory0().setFloat64(arg0 + 8 * 1, isLikeNone(ret) ? 0 : ret, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, !isLikeNone(ret), true);
}

export function __wbindgen_number_new(arg0) {
  const ret = arg0;
  return addHeapObject(ret);
}

export function __wbindgen_object_clone_ref(arg0) {
  const ret = getObject(arg0);
  return addHeapObject(ret);
}

export function __wbindgen_object_drop_ref(arg0) {
  takeObject(arg0);
}

export function __wbindgen_string_get(arg0, arg1) {
  const obj = getObject(arg1);
  const ret = typeof obj === "string" ? obj : undefined;
  var ptr1 = isLikeNone(ret)
    ? 0
    : passStringToWasm0(ret, wasm.__wbindgen_malloc, wasm.__wbindgen_realloc);
  var len1 = WASM_VECTOR_LEN;
  getDataViewMemory0().setInt32(arg0 + 4 * 1, len1, true);
  getDataViewMemory0().setInt32(arg0 + 4 * 0, ptr1, true);
}

export function __wbindgen_string_new(arg0, arg1) {
  const ret = getStringFromWasm0(arg0, arg1);
  return addHeapObject(ret);
}

export function __wbindgen_throw(arg0, arg1) {
  throw new Error(getStringFromWasm0(arg0, arg1));
}
